'use strict';

angular.module('cgmemApp')
.controller('FrontDeskKioskPaymentsCtrl', function ($scope, AppConfig, CheckIn, $uibModal) {

    this.items = [];
    $scope.$on('socket:unpaidGuestCheckin', (ev, d) => this.items.push(d) && console.log(d));

    this.done = idx => {
        var checkIns = [];
        var ci = {
            _id: null,
            guestOf: this.items[idx].hostMemberId,
            method: 'Staff'
        }

        for (var i = 0; i < this.items[idx].guestQty; i++)
            checkIns.push(ci);

        CheckIn.checkIn(checkIns);
        this.items.splice(idx,1);
    }

    this.cancel = idx => this.items.splice(idx,1);
});
